import React from 'react';
import loadable from '@loadable/component';

const LongTermDurationPicker = loadable(() =>
  import('@justpark/ui/src/components/LongTermDurationPicker')
);

type Props = {
  className: string,
  label: string,
  selected: string,
  onOptionSelect: () => {}
};

const LazyLongTermDurationPicker = (props: Props) => {
  const { className, ...rest } = props;
  return (
    <LongTermDurationPicker
      {...rest}
      fallback={<div className={className}>Loading...</div>}
    />
  );
};

export default LazyLongTermDurationPicker;
